import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, Input, inject } from '@angular/core';

import { LoaderComponentComponent } from '@base/common/components/loader/loader.component';

import { ModalRef } from './../../trilogy/modal/modal-ref';
import { PaymentStep } from './../stepper/steps/payment.step';

@Component({
    selector: 'checkout-payment-error-modal',
    templateUrl: './payment-error-modal.component.html',
    styleUrl: 'payment-error-modal.component.scss',
    imports: [CommonModule, LoaderComponentComponent],
    standalone: true,
})
export class PaymentErrorModalComponent {
    @Input() modalRef: ModalRef<this>;
    @Input() younitedRedirectionError: boolean;

    public title: string = 'On va devoir faire autrement';
    public subtitle: string = "D'autres solutions vous attendent sur la page de paiement";

    private paymentStep: PaymentStep = inject(PaymentStep);
    @Inject(DOCUMENT) private document: Document = inject(DOCUMENT);

    /**
     * Redirect to payment page when user came from younited
     * else close then refresh payment page
     */
    public goToPayment(): void {
        if (this.younitedRedirectionError) {
            this.document.location.href = this.paymentStep.routerLink;
        } else {
            this.modalRef.close();
        }
    }
}
